import React, { useEffect } from "react";
//import { Link } from "react-router-dom";
import "./FlipCardChildren.css";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Pillars() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // return (
  //   <div style={{ paddingBottom: "90px", paddingTop: "120px" }}>
  //     <center>
  //       <div className="ban-gap">
  //         <div className="icon-container-empower">
  //           <div
  //             className="icon-column"
  //             id="column1"
  //             data-aos="fade-up"
  //             data-aos-duration="2500"
  //           >
  //             <div aria-label="button" style={{ cursor: "not-allowed" }}>
  //               <div div className="Children-flip-button-image-1">
  //                 <h1 className="topic-overlay-conserve Children-topic-overlay">
  //                   CHILDREN AND EDUCATION
  //                 </h1>
  //               </div>
  //             </div>
  //           </div>
  //           <div
  //             className="icon-column"
  //             id="column2"
  //             data-aos="fade-up"
  //             data-aos-duration="2500"
  //           >
  //             <a href="/support/wellbeing/" aria-label="button">
  //               <div div className="Children-flip-button-image-2">
  //                 <h1 className="topic-overlay-conserve Children-topic-overlay">
  //                   WELLBEING
  //                 </h1>
  //               </div>
  //             </a>
  //           </div>
  //           <div
  //             className="icon-column"
  //             id="column2"
  //             data-aos="fade-up"
  //             data-aos-duration="2500"
  //           >
  //             <a href="/support/environment/" aria-label="button">
  //               <div div className="Children-flip-button-image-3">
  //                 <h1 className="topic-overlay-conserve Children-topic-overlay">
  //                   ENVIRONMENT
  //                 </h1>
  //               </div>
  //             </a>
  //           </div>
  //         </div>
  //       </div>
  //     </center>
  //   </div>
  // );

  return (
    <div style={{ paddingBottom: "90px", paddingTop: "120px" }}>
      <center>
        <div className="ban-gap">
          <div className="icon-container">
            {/* ENERGY */}
            <div className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <div style={{ cursor: "not-allowed" }}>
                <div className="image-box Children-flip-button-image-1" />
                <h1 className="topic-title-conserve"> Children and Education</h1>
              </div>
            </div>

            {/* WATER */}
            <div className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <a href="/support/wellbeing/" aria-label="button">
                <div className="image-box Children-flip-button-image-2" />
                <h1 className="topic-title-conserve">Wellbeing</h1>
              </a>
            </div>

            {/* WASTE */}
            <div className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <a href="/support/environment/" aria-label="button">
                <div className="image-box Children-flip-button-image-3" />
                <h1 className="topic-title-conserve">Environment</h1>
              </a>
            </div>

          </div>
        </div>
      </center>
    </div>
  );
}
